import { Icon } from 'semantic-ui-react';

type MappingsAlternativesIndicationPropsType = {
    highlightAlternatives: () => void;
    unhighlightAlternatives: () => void;
};

function MappingsAlternativesIndication({
    highlightAlternatives,
    unhighlightAlternatives,
}: MappingsAlternativesIndicationPropsType) {
    return (
        <Icon
            onPointerEnter={highlightAlternatives}
            onPointerLeave={unhighlightAlternatives}
            color="yellow"
            name="info"
        />
    );
}

export default MappingsAlternativesIndication;
